import { render, staticRenderFns } from "./table-approved.vue?vue&type=template&id=3ed70f17"
import script from "./table-approved.vue?vue&type=script&lang=js"
export * from "./table-approved.vue?vue&type=script&lang=js"
import style0 from "./table-approved.vue?vue&type=style&index=0&id=3ed70f17&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports